import { useCurrentUser } from "./use-current-user";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { logout } from "../api/auth-request";

const logoutUser = async () => {
  const response = await logout();
  return response.data;
};

export const useLogoutUser = () => {
  const { loadUser } = useCurrentUser();

  const { mutate } = useMutation({
    mutationFn: logoutUser,
    onSuccess: () => {
      toast.success("Logout Successfully!");
      loadUser();
    },
  });

  return { logout: mutate };
};
